module.exports = __webpack_public_path__ + "static/hethuis-7e3e27c0476a24b8ee3c1336d74916b8.jpg";